// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__OAmfe","footer":"ChangeClinic_footer__3yaeJ"};